<div class="btn-lista-desejo btn-header-action" (click)="_onClick()">
    <img defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/coracao.svg" width="25px" height="25px" alt="Meus Favoritos" />    
    <div class="text">
        Meus<br>
        <strong>Favoritos</strong>
    </div>    
</div>    
